import { QueryClient } from '@tanstack/react-query';

export const mockClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: Infinity,
			retry: false
		}
	}
});
